import request from '@/utils/requestYkp';
import { ApiPrefix } from '@/constants/constants';

export default {
	// 获取企业特定业务列表
	getElecTspz: (params?: any) => {
		return request({
			url: ApiPrefix.YkpApiDefault + '/elec/getElecTspz.do',
			method: 'GET',
			params,
		});
	},
	// 获取开票员信息列表
	getKpyList: (params?: any) => {
		return request({
			url: ApiPrefix.YkpApiDefault + '/kpyxx/getKpyList.do',
			method: 'POST',
			data: params,
		});
	},
	// 保存开票员配置信息
	saveKpyPzxx: (params?: any) => {
		return request({
			url: ApiPrefix.YkpApiDefault + '/kpyxx/saveKpyPzxx.do',
			method: 'POST',
			data: params,
		});
	},
	// 查询开票员配置信息列表
	getKpyPzxx: (params?: any) => {
		return request({
			url: ApiPrefix.YkpApiDefault + '/kpyxx/getKpyPzxx.do',
			method: 'GET',
			params,
		});
	},
	// 查看权限详情
	getKpqxDetail: (params: any) => {
		return request({
			url: ApiPrefix.YkpApiDefault + '/kpqx/zxtDetail.do',
			method: 'GET',
			params,
		});
	},
	//子系统保存开票权限设置
	saveKpqx: (data: any) => {
		return request({
			url: ApiPrefix.YkpApiDefault + '/kpqx/zxtSaveKpqx.do',
			method: 'POST',
			data,
		});
	},
	// 获取授权账号列表
	getAuthList: (id: string) => {
		return request({
			url: ApiPrefix.YkpApiDefault + '/kpyxx/getKpyAuth.do?userId=' + id,
			method: 'get',
		});
	},
};
